import { render } from "./ProductCardSolarSimple.vue?vue&type=template&id=0bce18c2"
import script from "./ProductCardSolarSimple.vue?vue&type=script&lang=js"
export * from "./ProductCardSolarSimple.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__